import { imageTransformsToUrl } from "./transforms.js";
/**
 * Get an upload's online URLs including thumbnails. Note that this does not check the local database.
 */
export function uploadUrl(imageUrl, companyId, id) {
    return {
        url: imageUrl + "/" + companyId + "/" + id,
        transform: (input) => imageTransformsToUrl(imageUrl, companyId, id, input)
    };
}
